<template>
    <div>
        <div v-show="!webSave">
            <div class="buttons top">
                <button class="btn btn-lg btn-create">New Website</button>
                <button class="btn btn-lg btn-create">Existing Website</button>
             </div>
            <div class="form-group">
                <label class="control-label">Company</label>
                <company :create="true" :errorName="model.errorName" v-model="model.company" :min-length="0"></company>
            </div>
            <div class="form-group">
                <label class="control-label">What type of website?</label>
                <p class="instruct-sm" style="top:10px;">Click to select Your CMS</p>
            </div>
            <ul class="cms-app-list list-inline">
                <li v-for="(app, index) in apps" @click="setApp(app)" class="clickable" :class="{ 'active': app === model.app_id }">
                    <i v-if="app!='wix'" v-bind:class="'icon icon-' + app"></i>
                    <i v-if="app=='wix'" v-bind:class="'fab fa-wix ' + app"></i>
                    <h6>{{ convertName(app) }}</h6>
                </li>
            </ul>

            <txt name="site_name" label="Site Name" v-model="model.site_name"></txt>
            <p class="instruct-sm">Name your website eg. "John's Blog"</p>

            <div class="popup-split left">
                <txt id="domain" label="live_domain" v-model="model.domain"></txt>
                    <p class="instruct-sm">If you wish to deploy directly to the live domain, ensure the Dev Domain is empty.</p>
            </div>

            <div class="popup-split right">
                <div class="form-group">
                     <label for="dev_domain" class="control-label">Dev Domain</label>
                     <div v-if="model.app_id!='wix'" class="input-group">
                          <input type="text" class="form-control" id="dev_domain" v-model="model.dev_domain">
                          <span class="input-group-addon">{{ model.demo_domain }}</span> <!-- {{model.demo_domain}} -->
                     </div>
                     <!-- different dev URL format for Wix -->
                     <div v-if="model.app_id=='wix'" class="input-group">
                          <span class="input-group-addon" style="padding:0px!important;">{{ model.demo_domain }}</span> <!-- {{model.demo_domain}} -->
                          <input type="text" class="form-control" id="dev_domain" v-model="model.dev_domain">
                     </div>
                    <br />
                    <p class="instruct-sm">This is the address for your development site. If this field is populated, your website will be deployed to this address.</p>
                </div>
            </div>

            <div class="alert alert-danger" v-if="hasServers">Please add a server to your account to continue.</div>

            <div class="popup-split left">
                <list id="server_id" label="Web Server" :list='servers' :value="model.server_id" v-model="model.server_id" :usekey="true"></list>
            </div>
            <div class="popup-split right">
                <div class="form-group disabled">
                    <label class="control-label disabled"> Theme</label>
                    <select class="form-control disabled" disabled="disabled" placeholder="">
                        <option value="" selected disabled> - Feature Coming Soon - </option>
                    </select>
                </div>
            </div>

            <div class="buttons">
                <button @click.prevent="store" type="submit" class="btn btn-success btn-sm" :disabled="!submitReady">
                    <span v-if="submitReady"><i class="icon icon-tick"></i> Deploy Site</span>
                    <span v-if="!submitReady"><i class="icon icon-spinner fa-spin"></i> loading...</span>
                </button>
            </div>
        </div>
        <div v-show="webSave" id="websiteSaving">
            <div id="savedLinks" v-if="websiteUrl !== ''">
                <span>Your website has been successfully deployed. <br>What do you want to do next?</span><br><br>
                <a :href="websiteUrl.view" target="_blank" class="btn btn-primary">Visit Website</a>
                <a :href="websiteUrl.edit" target="_blank" class="btn btn-primary">Website Admin</a>
                <!-- Company -->
                <a :href="websiteUrl.company.link" class="btn btn-primary">{{ websiteUrl.company.name }}</a>
            </div>
            <div v-else>
                <i class="icon icon-cog fa-spin"></i>
                <span v-if="deployNotice.length">{{ deployNotice }}...</span>
                <span v-else>Please wait...</span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            name: { default: '' },
        },
        components: {
            'company': require('../../components/autocomplete/company.vue').default,
        },
        computed: {
            apps() {
                if (window.isInternal === '1'){
                    // return ['wordpress', 'opencart', 'wpengine', 'shopify', 'wix'];
                    return ['wordpress','shopify'];
                }
                return ['wordpress'];
            },
            hasServers() {
                if (typeof this.servers === 'object') {
                    return Object.keys(this.servers).length === 0 && this.servers.constructor === Object;
                }
                return this.servers.length;
            },
            servers() {
                if (typeof window['servers'] !== 'undefined') {
                    return window.servers;
                }
                return [];
            }
        },
        data() {
            return {
                deployNotice: false,
                websiteUrl: '',
                webSave: false,
                demo_domain: window.DEMO_DOMAIN,
                submitReady: true,
                model: {
                    errorName: 'websiteCreate',
                    app_id: 'wordpress',
                    public_id: 0,
                    site_name: '',
                    panelName: this.name,
                    company: '',
                    is_live: 0,
                    server_id: '',
                    lock_dev_domain: false,
                    domain: '',
                    dev_domain: '',
                    demo_domain: window.DEMO_DOMAIN,
                    username: '',
                    password: '',
                    cms_password: '',
                    admin_url: '',
                    ftp_list: []
                }
            }
        },
        created() {
            this.resetPanel();
            this.checkServer();
            this.$eventHub.$on('websiteSubmit', this.store);
            this.$eventHub.$on('setWebsite', this.setWebsite);
            this.$eventHub.$on('saving' + this.name, this.savingWebsite);
            this.$eventHub.$on('websiteCreateUpdate', this.websiteComplete);
            this.$eventHub.$on('websiteCreateUpdate' + this.name, this.websiteCompleteName);
            this.$eventHub.$on('emitErrors', this.resetPanel);
            this.$eventHub.$on('deployUpdate', this.deployUpdate);
        },
        watch: {
            'model.server_id': function (val) {
                if (val === 'WPE') {
                    this.model.demo_domain = '.wpengine.com';
                    return;
                }
                if (val === 'shopify') {
                    this.model.demo_domain = '.myshopify.com';
                    return;
                }
                if (val === 'wix') {
                    this.model.demo_domain = 'myworkmywix.wixsite.com/';
                    return;
                }
                this.model.demo_domain = this.demo_domain;
            },
            'model.site_name': function(val){
                if(this.model.lock_dev_domain) return;
                this.model.dev_domain = cleanUrl(val);
            }
        },
        methods: {
            convertName(app) {
                if (app === 'wordpress') {
                    return 'WordPress';
                }
                if (app === 'wpengine') {
                    return 'WP Engine';
                }
                if (app === 'wix'){
                    return 'Wix';
                }
                return app.ucfirst();
            },
            deployUpdate(data) {
                if (data.panelName === this.name) {
                    this.deployNotice = data.title;
                }
            },
            resetPanel() {
                this.webSave = false;
                this.$eventHub.$emit('updateDialogHeading', {
                    heading: 'Create Website',
                    icon: 'icon-create-circle'
                });
            },
            websiteComplete(data){
                if (this.name.length && this.name !== data.panelName) {
                    fyi('Panel name does not match. Not updating');
                    return;
                }
                this.$eventHub.$emit('updateDialogHeading', {
                    heading: 'Website Deployed',
                    icon: 'icon-tick'
                });
                this.websiteUrl = data;
            },
            websiteCompleteName(data) {
                data.panelName = this.name;
                this.websiteComplete(data);
            },
            lockDevDomain(){
                if (this.model.dev_domain == '') {
                    this.model.lock_dev_domain = false;
                    return;
                }
                this.model.lock_dev_domain = true;
            },
            store() {
                this.model.preventDialogClose = true;
                this.model.modal = false;
                this.$store('/api/website/store', this);
                this.$eventHub.$emit('latest-notif', {
                    title: 'Website Deploying',
                    timeout: true
                });
                this.deployUpdate({
                    panelName: this.name,
                    title: 'Website deploying'
                })
            },
            savingWebsite(){
                this.webSave = true;
                this.$eventHub.$emit('updateDialogHeading', {
                    heading: 'Website Deploying',
                    icon: 'icon-cog fa-spin'
                });
            },
            setApp(app){
                this.model.app_id = app;
                this.checkServer();
            },
            checkServer(){
                if (typeof window.DEFAULT_SERVERS['all'] !== 'undefined') {
                    this.model.server_id = window.DEFAULT_SERVERS['all'];
                }
                if (typeof window.DEFAULT_SERVERS[this.model.app_id] !== 'undefined') {
                    this.model.server_id = window.DEFAULT_SERVERS[this.model.app_id];
                }
            },
            setWebsite(data) {
                this.model = this.$setData(data, this.model);
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('websiteSubmit', this.store);
            this.$eventHub.$off('setWebsite', this.setWebsite);
            this.$eventHub.$off('saving' + this.name, this.savingWebsite);
            this.$eventHub.$off('websiteCreateUpdate', this.websiteComplete);
            this.$eventHub.$off('emitErrors', this.resetPanel);
            this.$eventHub.$off('deployUpdate', this.deployUpdate);
        }
    }
</script>
<style>
    #savedLinks {
        text-align: center;
        min-height: 100px;
    }
    .clickable{
        cursor: pointer;
    }
</style>